/** @format */

import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { HomeDirectiveModule } from '@home/utils';
import { HtmlSanitizerPipe } from '@shared/utils/pipes';
import { KrakenService } from './kraken.service';
import { WINDOW } from '@shared/data-access/services';
import { take } from 'rxjs/operators';

@Component({
	selector: 'shared-components-engage-kraken',
	templateUrl: './kraken.component.html',
	styleUrl: './kraken.component.scss',
	imports: [HomeDirectiveModule, HtmlSanitizerPipe]
})
export class KrakenComponent implements OnInit {
	@Input()
	data: any;

	@Input()
	addlData: any;

	@Output()
	loadEvent = new EventEmitter<{ isError: boolean }>();

	krakenContent: string;

	get isIE() {
		return (
			window.navigator.userAgent.indexOf('MSIE ') > 0 ||
			// eslint-disable-next-line no-useless-escape
			!!navigator.userAgent.match(/Trident.*rv\:11\./)
		);
	}

	constructor(
		private krakenService: KrakenService,
		@Inject(WINDOW) private window: Window
	) {}

	ngOnInit() {
		if (this.data[0] && this.data[0].pageName) {
			this.krakenService
				.get(this.data[0].pageName)
				.pipe(take(1))
				.subscribe({
					next: (content) => {
						this.handleKrakenContentResponse(this.data[0].pageName, content);
					},
					error: () => {
						this.loadEvent.emit({ isError: true });
					}
				});
		}
	}

	public handleKrakenContentResponse(pageName, content) {
		if (content?.includes('href="#')) {
			content = this.anchorLinkFix(content);
		}
		if (content?.includes('<script') && !this.isIE) {
			content = this.blockScripts(content);
		}
		this.loadEvent.emit({ isError: false });
		this.krakenContent = `<!-- BEGIN - ${pageName}-content -->
			${content}
			<!-- END - ${pageName}-content -->`;
	}

	public anchorLinkFix(content) {
		const splitContent = content.split('href="#');
		const revisedContent = [];
		const pageUrl = this.window.location.pathname;
		for (let i = 0; i < splitContent.length; i++) {
			const item = splitContent[i];
			if (i > 0) {
				revisedContent.push(`href="${pageUrl}#${item}`);
			} else {
				revisedContent.push(item);
			}
		}
		return revisedContent.join('');
	}

	public blockScripts(content) {
		const tmpDiv = window.document.createElement('div');
		tmpDiv.id = 'tmpScriptHolder';
		tmpDiv.innerHTML = content;
		const scripts = tmpDiv.querySelectorAll('script') as any as HTMLScriptElement[];
		for (let i = 0; i < scripts.length; i++) {
			const v = scripts[i];
			v.type = !['text/x-handlebars-template'].includes(v.type) ? 'iliad/blocked' : v.type;
		}
		const response = tmpDiv.innerHTML;
		tmpDiv.remove();
		return response;
	}
}
